export default __webpack_public_path__ + "static/media/char_body_prem_006.6f69185f.png";